/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

/**
 * @COMPONENT_NAME MachineTypeEmbed
 * @DESCRIPTION 다른 화면에 임베디드 컴포넌트로 사용될 수 있는 설비 유형 관리 컴포넌트
 *
 * @PROPS
 *    - {Function} onSelect - 설비 유형 선택 시 호출되는 콜백 함수
 *    - {Function} onApiInitialized - API 초기화 시 호출되는 콜백 함수
 *
 * @CALLBACKS
 *    - {Function} onSelect - 설비 유형이 선택되었을 때 부모 컴포넌트에 알리는 콜백
 */
function MachineTypeEmbed(props) {
    const { t } = useTranslation();
    const { onSelect, onApiInitialized } = props;

    const table = "MachineType";
    const view = "VwMachineType";

    const [grid, setGrid] = useState();

    useEffect(() => {
        if (grid) {
            grid.selectionChanged.addHandler(
                debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        if (onSelect) {
                            onSelect(grid.selectedItems[0]);
                        }
                    } else {
                        if (onSelect) {
                            onSelect([]);
                        }
                    }
                }, 10)
            );

            grid.itemsSourceChanged.addHandler(
                debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        if (onSelect) {
                            onSelect(grid.selectedItems[0]);
                        }
                    } else {
                        if (onSelect) {
                            onSelect([]);
                        }
                    }
                }, 10)
            );
        }
    }, [grid, onSelect]);

    const onGridInitialized = (grid) => {
        grid.selectionMode = "Row";
        setGrid(grid);
    };

    return (
        <BasicCrudScreenType
            id={table}
            headerTitle={t("term.machineType")}
            table={table}
            view={view}
            noCreate
            noEdit
            noDelete
            noExcel
            onInitialized={onGridInitialized}
            onApiInitialized={onApiInitialized}
        />
    );
}

export default MachineTypeEmbed;
